import { apiClient } from '@/lib/api.ts'

export interface UserTanssCredentials {
  tanssUser: string
  tanssPassword: string
  tanss2faCode: string
  _legacySource?: boolean
}

export function getUserTanssCredentials() {
  return apiClient.get<UserTanssCredentials>('/settings/user/tanss')
}

export function updateUserTanssCredentials(creds: Omit<UserTanssCredentials, '_legacySource'>) {
  return apiClient.put<{ ok: boolean }>('/settings/user/tanss', creds)
}

export function searchTanssCompanies(query: string) {
  return apiClient.get<{ data: Array<Record<string, unknown>> }>('/tanss/companies/search', { params: { q: query } })
}

export function getKatTagGroups() {
  return apiClient.get('/admin/tanss/kat-tags')
}

export function getTeamsBridgeStartMessage() {
  return apiClient.get('/tanss-teams-bridge/start-message')
}

export function previewTeamsBridgeStartMessage(template: string) {
  return apiClient.post<{ html: string }>('/tanss-teams-bridge/start-message/preview', { template })
}

export function saveTeamsBridgeStartMessage(template: string) {
  return apiClient.put<{ template: string }>('/tanss-teams-bridge/start-message', { template })
}

export interface TanssPortalTestResult {
  ok: boolean
  durationMs: number
  employeeCount?: number
  sample?: Array<{ id: unknown; name: unknown; active: unknown; listType: unknown }>
  error?: { message: string; code?: string }
}

export function testTanssPortalConnection() {
  return apiClient.post<TanssPortalTestResult>('/tanss/test-portal-connection', {})
}
